"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessTokenTypesClassNames = exports.accessTokenTypes = exports.CLIENT_CREDENTIALS_GRANT_TYPE = exports.CREATE_CLIENT_MODAL_KEY = exports.SYSTEM_CLIENT = exports.CLIENTS_STATE_KEYS = exports.CLIENTS_STATE_KEY_NAME = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _accessTokenTypesClas;

var CLIENTS_STATE_KEY_NAME = 'clients';
exports.CLIENTS_STATE_KEY_NAME = CLIENTS_STATE_KEY_NAME;
var CLIENTS_STATE_KEYS = {
  CREATE_CLIENT: 'createClient',
  UPDATE_CLIENT: 'updateClient',
  LIST: 'list'
};
exports.CLIENTS_STATE_KEYS = CLIENTS_STATE_KEYS;
var SYSTEM_CLIENT = '*';
exports.SYSTEM_CLIENT = SYSTEM_CLIENT;
var CREATE_CLIENT_MODAL_KEY = 'create-client-modal';
exports.CREATE_CLIENT_MODAL_KEY = CREATE_CLIENT_MODAL_KEY;
var CLIENT_CREDENTIALS_GRANT_TYPE = 'client_credentials';
exports.CLIENT_CREDENTIALS_GRANT_TYPE = CLIENT_CREDENTIALS_GRANT_TYPE;
var accessTokenTypes = {
  JWT: 'Jwt',
  REFERENCE: 'Reference'
};
exports.accessTokenTypes = accessTokenTypes;
var accessTokenTypesClassNames = (_accessTokenTypesClas = {}, (0, _defineProperty2.default)(_accessTokenTypesClas, accessTokenTypes.JWT, 'olive-100'), (0, _defineProperty2.default)(_accessTokenTypesClas, accessTokenTypes.REFERENCE, 'orchid-100'), _accessTokenTypesClas);
exports.accessTokenTypesClassNames = accessTokenTypesClassNames;
//# sourceMappingURL=constants.js.map